(function () {
  var instances = {};

  function getSectionRoot(container, selector) {
    if (!container) return null;
    if (container.matches && container.matches(selector)) return container;
    return container.querySelector(selector);
  }

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getSlidesPerView(root) {
    var count = parseInt(root.dataset.slideCount, 10) || 1;
    var target;
    if (isMobile()) {
      target = 1.8;
    } else if (window.matchMedia('(max-width: 989px)').matches) {
      target = 2;
    } else {
      target = 3;
    }
    return Math.min(target, count);
  }

  function getSpaceBetween(root) {
    var desktop = parseInt(root.dataset.spaceDesktop, 10) || 16;
    var mobile = parseInt(root.dataset.spaceMobile, 10) || 12;
    return isMobile() ? mobile : desktop;
  }

  function getSwiperLayout(root) {
    return {
      slidesPerView: getSlidesPerView(root),
      spaceBetween: getSpaceBetween(root),
      centeredSlides: false,
      slideToClickedSlide: false,
      centerInsufficientSlides: false
    };
  }

  function pauseAllVideos(root, exceptWrap) {
    root.querySelectorAll('[data-nwvt-video]').forEach(function (wrap) {
      if (exceptWrap && wrap === exceptWrap) return;
      var video = wrap.querySelector('video');
      if (!video) return;
      video.pause();
      wrap.classList.remove('is-playing');
    });
  }

  function bindVideoClicks(root) {
    if (root.dataset.videoBound === 'true') return;
    root.dataset.videoBound = 'true';

    root.addEventListener('click', function (event) {
      var wrap = event.target.closest('[data-nwvt-video]');
      if (!wrap || !root.contains(wrap)) return;

      var video = wrap.querySelector('video');
      if (!video) return;

      event.preventDefault();

      if (video.paused) {
        pauseAllVideos(root, wrap);
        video.play();
        wrap.classList.add('is-playing');
      } else {
        video.pause();
        wrap.classList.remove('is-playing');
      }
    });

    root.querySelectorAll('[data-nwvt-video] video').forEach(function (video) {
      video.addEventListener('ended', function () {
        var wrap = video.closest('[data-nwvt-video]');
        if (wrap) wrap.classList.remove('is-playing');
      });
      video.addEventListener('pause', function () {
        var wrap = video.closest('[data-nwvt-video]');
        if (wrap) wrap.classList.remove('is-playing');
      });
    });
  }

  function destroySwiper(id) {
    if (!instances[id]) return;
    instances[id].destroy(true, true);
    delete instances[id];
  }

  function init(root) {
    if (!root || typeof Swiper === 'undefined') return;

    var swiperEl = root.querySelector('.nw-video-testimonials__swiper');
    if (!swiperEl) return;

    bindVideoClicks(root);

    var id = swiperEl.dataset.blockId;
    destroySwiper(id);

    var layout = getSwiperLayout(root);

    instances[id] = new Swiper(swiperEl, {
      slidesPerView: layout.slidesPerView,
      spaceBetween: layout.spaceBetween,
      centeredSlides: layout.centeredSlides,
      slideToClickedSlide: layout.slideToClickedSlide,
      centerInsufficientSlides: layout.centerInsufficientSlides,
      loop: isMobile(),
      watchOverflow: false,
      speed: 400,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: root.querySelector('.nw-video-testimonials__arrow--prev'),
        nextEl: root.querySelector('.nw-video-testimonials__arrow--next')
      },
      on: {
        slideChange: function () {
          pauseAllVideos(root);
        }
      }
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.nw-video-testimonials').forEach(init);
  }

  function refresh(root) {
    if (!root) return;
    var swiperEl = root.querySelector('.nw-video-testimonials__swiper[data-block-id]');
    if (!swiperEl) return;

    var id = swiperEl.dataset.blockId;
    var swiper = instances[id];

    // loop can only be toggled by re-creating the instance, so always
    // re-init on breakpoint changes instead of patching params in place.
    if (!swiper || swiper.params.loop !== isMobile()) {
      init(root);
      return;
    }

    var layout = getSwiperLayout(root);
    swiper.params.slidesPerView = layout.slidesPerView;
    swiper.params.spaceBetween = layout.spaceBetween;
    swiper.params.centeredSlides = layout.centeredSlides;
    swiper.params.slideToClickedSlide = layout.slideToClickedSlide;
    swiper.params.centerInsufficientSlides = layout.centerInsufficientSlides;
    swiper.update();
  }

  function handleResize() {
    document.querySelectorAll('.nw-video-testimonials').forEach(refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('larine:swiper', function () {
    initAll();
  });

  window.addEventListener('resize', handleResize);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = getSectionRoot(event.target, '.nw-video-testimonials');
    if (!root) return;
    var swiperEl = root.querySelector('.nw-video-testimonials__swiper[data-block-id]');
    if (swiperEl) destroySwiper(swiperEl.dataset.blockId);
    delete root.dataset.videoBound;
    pauseAllVideos(root);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var root = getSectionRoot(event.target, '.nw-video-testimonials');
    if (root) refresh(root);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = getSectionRoot(event.target, '.nw-video-testimonials');
    if (root) refresh(root);
  });
})();
